import { IAddress, IBaseListResponse, IPharmacyAddress } from './common.dto';
import {
  IOrderLineItem,
  IOrderPayment,
  IOrderRequirement,
  IPharmacyOrder,
  OrderSource,
  OrderStatusKey
} from './order.dto';

export interface IPurchase extends IOrderLineItem {
  _id: string;
  orderId: string;
  createdAt: Date;
  orderStatus: OrderStatusKey;
  extras?: any;
  meta?: any;
  source: OrderSource;
  shippingAddress: IAddress;
  billingAddress?: string; // not in IOrder
  shippingCost?: number; // not in IOrder
  tax?: number; // not in IOrder
  totalAmount: number;
  discountAmount: number;
  baseAmount: number;
  trackingCode?: string;
  trackingLink?: string;
  trackingCarrier?: string;
  paymentMethod?: string; // not in IOrder
  requirements?: IOrderRequirement[];
  creditUsedAmount?: number;
  paymentMethodLast4?: string;
  paymentMethodType?: string;
  subscriptionId?: string;
  version?: number;
  // Pharmacy transfer fields
  transferOut?: boolean;
  pharmacyAddress?: IPharmacyAddress;
  payment?: IOrderPayment;
  giftCardUsedAmount?: number;
  pharmacyOrder?: IPharmacyOrder;
  carrier?: string;
}

export class Purchase extends IOrderLineItem {
  orderId: string;
  createdAt: Date;
  orderStatus: string;
  declare extras?: any;
  meta?: any;
  source: OrderSource;
  shippingAddress: IAddress;
  pharmacyAddress?: IPharmacyAddress;
  transferOut?: boolean;
  billingAddress?: string; // not in IOrder
  shippingCost?: number; // not in IOrder
  tax?: number; // not in IOrder
  totalAmount: number;
  discountAmount: number;
  baseAmount: number;
  trackingCode?: string;
  trackingLink?: string;
  trackingCarrier?: string;
  paymentMethod?: string; // not in IOrder
  declare requirements?: IOrderRequirement[];
  creditUsedAmount?: number;
  paymentMethodLast4?: string;
  paymentMethodType?: string;
  subTotalAmount?: number;
  coupon?: string;
  payment?: IOrderPayment;
  giftCardUsedAmount?: number;
  carrier?: string;
}

export class PurchaseListItem {
  orderId: string;
  productId: string;
  name: string;
  createdAt: Date;
  orderStatus: string;
  price: number;
  listPrice?: number;
  imageUrl?: string;
  payment?: IOrderPayment;
  giftCardUsedAmount?: number;
  carrier?: string;
}

export type PurchasesResponse = IBaseListResponse<IPurchase>;
